import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
} from '@angular/core';

@Component({
    selector: 'ios-install-drawer',
    templateUrl: './ios-install-drawer.component.html',
    styleUrl: './ios-install-drawer.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IosInstallDrawerComponent {
    @Input() showIosInstallDrawer: boolean;
    @Output() closeIosInstallDrawer: EventEmitter<any> = new EventEmitter();
}
